import { render, staticRenderFns } from "./TradeOverview.vue?vue&type=template&id=1d1a7632&scoped=true&"
import script from "./TradeOverview.vue?vue&type=script&lang=js&"
export * from "./TradeOverview.vue?vue&type=script&lang=js&"
import style0 from "./TradeOverview.vue?vue&type=style&index=0&id=1d1a7632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a7632",
  null
  
)

export default component.exports